import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BlogData from "../Data/BlogData.json";

const Blog = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="breadcrumb-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-12">
              <div className="breadcrumb-content">
                <h3>News & Trending Topics</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="blog-sidebar-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-12">
              <div className="blog-sidebar-inner">
                <div className="row">
                  {BlogData.slice(3, 6).map((SingleBlogCard) => (
                    <div
                      className="col-lg-6 col-md-6 col-12"
                      key={SingleBlogCard.id}
                    >
                      <div className={SingleBlogCard.singleclass}>
                        <div className="blog-head">
                          <img src={SingleBlogCard.img} alt="#" />
                        </div>
                        <div className="blog-content">
                          <ul className="blog-meta">
                            <li className="dot">{SingleBlogCard.date}</li>
                            <li>{SingleBlogCard.time}</li>
                          </ul>
                          <h3 className="b-title">
                            <Link to="/blogsingle">{SingleBlogCard.title}</Link>
                          </h3>
                          <div className="blog-btn">
                            <Link
                              to="/blogsingle"
                              className="theme-btn primary"
                            >
                              <i className="icofont-arrow-right"></i>Read more
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* <div className="blog-bottom-btn">
                <Link to="#" className="theme-btn">
                  Load more
                </Link>
              </div> */}
            </div>
            <div className="col-lg-4 col-12">
              <div className="blog-sidebar-main">
                {/* <div className="sidebar-widget search-widget">
                  <form action="#">
                    <input type="text" placeholder="Search blog" required />
                    <button type="submit">
                      <i className="fa fa-search"></i>
                    </button>
                  </form>
                </div> */}
                <div className="sidebar-widget recent-blog">
                  <h5 className="sidebar-widget-title">Recent Blog</h5>
                  <div className="recent-blog-inner">
                    {BlogData.slice(0, 3).map((SingleRecent) => (
                      <div className="single-recent-blog" key={SingleRecent.id}>
                        <div className="recent-img">
                          <img src={SingleRecent.img} alt="#" />
                        </div>
                        <div className="recent-blog-content">
                          <h6 className="r-title">
                            <Link href="/blogsingle">{SingleRecent.title}</Link>
                          </h6>
                          <ul className="blog-meta recent-blog-meta">
                            <li className="dot">{SingleRecent.date}</li>
                            <li>{SingleRecent.time}</li>
                          </ul>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {/* <div className="sidebar-widget categories">
                  <h5 className="sidebar-widget-title">Categories</h5>
                  <ul>
                    <li>
                      <a href="#">isp digital</a>
                    </li>
                    <li>
                      <a href="#">web server</a>
                    </li>
                    <li>
                      <a href="#">internet</a>
                    </li>
                    <li>
                      <a href="#">download</a>
                    </li>
                    <li>
                      <a href="#">server</a>
                    </li>
                    <li>
                      <a href="#">business statistics</a>
                    </li>
                    <li>
                      <a href="#">business logic</a>
                    </li>
                    <li>
                      <a href="#">ubuntu</a>
                    </li>
                    <li>
                      <a href="#">ui design</a>
                    </li>
                    <li>
                      <a href="#">ux design</a>
                    </li>
                    <li>
                      <a href="#">startups</a>
                    </li>
                    <li>
                      <a href="#">technology</a>
                    </li>
                    <li>
                      <a href="#">web</a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
